import React from 'react';
import useScrollToTop from 'lib/hooks/useScrollToTop';
import PrivacyPolicy from 'components/Common/PrivacyPolicy';
import Page from 'components/Common/Page';

const Privacy = () => {
	// scroll to the top on load
	useScrollToTop();

	return (
		<Page className='page' fade title='Privacy Policy'>
			<div style={{ padding: '50px 5% 200px', color: '#053574' }}>
				<PrivacyPolicy />
			</div>
		</Page>
	);
};

export default Privacy;
